export type ColorScheme = {
  [key: string]: string;
};

export function applyColorScheme(schemeName: string, colorSchemes: Record<string, ColorScheme>): void {
  const scheme = colorSchemes[schemeName];

  if (!scheme) {
    console.warn(`Color scheme "${schemeName}" does not exist.`);

    return;
  }

  const root = document.documentElement;

  Object.entries(scheme).forEach(([variable, value]) => {
    root.style.setProperty(variable, `${value}`);
  });
}

export function getAvailableColorSchemes(colorSchemes: Record<string, ColorScheme>): string[] {
  return Object.keys(colorSchemes);
}
